export enum StatusId {

    // reservation
    rProvAnfrage = 10400,
    rAbklärung = 10415,
    rProvisorisch = 10430,
    rBestätigt = 10460,
    rDurchgeführt = 10465,
    rAbgesagt = 10470,
    rAbgelehnt = 10475,
    rAbgeschlossen = 10480,
    rStorniert = 10485,

    // ressource raum
    rrReservierbar = 40210,
    rrReservierbarBis = 40220,
    rrGesperrtBis = 40230,
    rrGesperrt = 40240

}
